import Event from "global-libs/event/event";
import ClientDetect from "global-libs/global-setup/client-detect";
import throttle from "global-libs/under-score/throttle";

const _event = new Event();
let rotAngle = 0;

// 初始化body基础样式
const root = document.body;
root.style.position = "absolute";
root.style.transformOrigin = "50% 50%";

let changeEventThrottle = throttle(()=>{
    _event.dispatchEvent({type:"change"});
},100,{leading:false});

const landscapeHandle = ()=>{
    let orientation = null;
    let angle = window.orientation;
    if(angle===0||angle===180){
        orientation = "portrait";
    }else if(angle===90||angle===-90){
        orientation = "landscape";
    }
    if(!orientation){
        return;
    }
    let cHeight = document.documentElement.clientHeight;
    let cWidth = document.documentElement.clientWidth;
    if(orientation==="portrait"){
        rotAngle = 90;
        root.style.transform = "rotate(90deg)";
        root.style.width = cHeight+"px";
        root.style.height = cWidth+"px";
        root.style.left = -(cHeight-cWidth)*0.5+"px";
        root.style.top = (cHeight-cWidth)*0.5+"px";
    }else if(orientation==="landscape"){
        rotAngle = 0;
        root.style.transform = "rotate(0deg)";
        root.style.width = cWidth+"px";
        root.style.height = cHeight+"px";
        root.style.left = "0px";
        root.style.top = "0px";
    }
    changeEventThrottle();
};

const ForceOrientation = {
    onChangeHandle(handle){
        _event.addEventListener("change",handle);
    },
    offChangeHandle(handle){
        _event.removeEventListener("change",handle);
    },
    //----------移动端强制横屏----------
    forceLandscape(){
        if(ClientDetect.isSmallScreen()){
            window.addEventListener("orientationchange",landscapeHandle,false);
            window.addEventListener("resize",landscapeHandle,{ passive: false });
            landscapeHandle();
        }
    },

    //----------转换事件位置信息----------
    orientationEventPoint(eventObject){
        if(rotAngle===0){
            return eventObject;
        }
        if(eventObject.__isOrientationEventPoint){
            return eventObject;
        }
        eventObject.__isOrientationEventPoint = true;
        if(rotAngle===90){
            let x,y;
            let clientWidth = document.documentElement.clientWidth;
            let screenWidth = window.screen.width;
            if(eventObject.clientX!==undefined){
                x = eventObject.clientY;
                y = eventObject.clientX;
                Object.defineProperties(eventObject,{
                    clientX:{
                        value:x,
                        configurable:true,
                        enumerable:true
                    },
                    clientY:{
                        value:clientWidth-y,
                        configurable:true,
                        enumerable:true
                    }
                })
            }
            if(eventObject.screenX!==undefined){
                x = eventObject.screenY;
                y = eventObject.screenX;
                Object.defineProperties(eventObject,{
                    screenX:{
                        value:x,
                        configurable:true,
                        enumerable:true
                    },
                    screenY:{
                        value:screenWidth-y,
                        configurable:true,
                        enumerable:true
                    }
                })
            }
            if(eventObject.pageX!==undefined){//后续可能需要校准和重新计算
                x = eventObject.pageY;
                y = eventObject.pageX;
                Object.defineProperties(eventObject,{
                    pageX:{
                        value:x,
                        configurable:true,
                        enumerable:true
                    },
                    pageY:{
                        value:clientWidth - y,
                        configurable:true,
                        enumerable:true
                    }
                })
            }
        }
        return eventObject;
    },
    
    //----------转换clientRect信息----------
    orientationClientRect(clientRect){
        if(rotAngle===0){
            return clientRect;
        }
        if(rotAngle===90){
            let clientWidth = document.documentElement.clientWidth;
            return {
                x:clientRect.top,y:clientWidth - clientRect.right,
                left:clientRect.top,top:clientWidth - clientRect.right,
                right:clientRect.bottom, bottom:clientWidth - clientRect.left,
                height:clientRect.width,width:clientRect.height
            };
        }
    },

    //----------转换宽高信息----------
    orientationWidthHeight(width,height){
        if(rotAngle===0){
            return {width:width,height:height};
        }else if(rotAngle===90){
            return {width:height,height:width};
        }
    }
};

export default ForceOrientation;